import {SECURE_CONTENT_STORE_NAME} from '../reducers/reducers'

export function getSecureContentPageContent(state, pageName) {
    const stored = state[SECURE_CONTENT_STORE_NAME] || { }
    return ((stored.items || {})[pageName] || {}).content
}
